type AbgwObject = {
  cluster_id: ID,
};
type AbgwAction = (obj: AbgwObject) => Promise<unknown> | unknown;
type AbgwOperation = 'changed';

type AbgwSocketEvent = {
  subsystem: string,
  type: string,
  operation: AbgwOperation,
  object: AbgwObject,
};

export const abgwNotificationHandler = (type: string, actionMap: Partial<Record<AbgwOperation, AbgwAction>>) => async (payload: AbgwSocketEvent) => {
  if (payload && payload.subsystem === 'abgw' && payload.type === type) {
    return actionMap[payload.operation]?.(payload.object);
  }
  return undefined;
};

export default abgwNotificationHandler;
